// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","buttonWrap":"TextUpdatesCallout_buttonWrap__7u1Zn","button":"TextUpdatesCallout_button__sRH+g"};